import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import { companyInfo, navLinks } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNavClick = (link, e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    
    if (link.isRoute) {
      // Navigate to route
      navigate(link.href);
    } else {
      // Handle hash navigation
      if (location.pathname !== '/') {
        // If not on home page, navigate to home first then scroll
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(link.href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        // Already on home page, just scroll
        const element = document.querySelector(link.href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector('#contact');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector('#contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="header">
      <div className="container header-content">
        <a 
          href="/" 
          className="logo-wrapper" 
          style={{ textDecoration: 'none' }}
          onClick={handleLogoClick}
          data-testid="logo-link"
        >
          <div className="logo">
            {companyInfo.name.slice(0, 2)}<span>{companyInfo.name.slice(2)}</span>
          </div>
          <div className="logo-tagline">{companyInfo.tagline}</div>
        </a>
        
        <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          {navLinks.map((link) => (
            <a 
              key={link.label}
              href={link.href}
              className={`nav-link ${link.isRoute && location.pathname === link.href ? 'active' : ''}`}
              onClick={(e) => handleNavClick(link, e)}
            >
              {link.label}
            </a>
          ))}
          <a 
            href="#contact" 
            className="btn-primary"
            onClick={handleContactClick}
          >
            Get Started
            <ArrowRight size={16} />
          </a>
        </nav>
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
